module.exports = __webpack_public_path__ + "img/GS_Profile-Sharon Bapela.858ad5fe.png";